import React from 'react';
import PropTypes from 'prop-types';
import { capitalize } from 'lodash';
import { securityColors, generateSecurityAnalysisLegendSubtext } from '../../utils/securityAnalysis';
import ColorLegend from '../common/ColorLegend';


const SecurityDetailColorLegend = ({ adequacy }) => {
  const label = `${capitalize(adequacy)} Indexed Data`;
  const color = securityColors[adequacy];
  const items = [
    {
      label,
      subtext: generateSecurityAnalysisLegendSubtext(adequacy),
      color
    }
  ];

  return (
    <ColorLegend
      items={items}
    />
  );
};

SecurityDetailColorLegend.propTypes = {
  adequacy: PropTypes.string.isRequired
};

export default SecurityDetailColorLegend;



// WEBPACK FOOTER //
// ./src/components/analytics/SecurityDetailColorLegend.js